import { motion } from 'framer-motion';
import { AthenaPresentationEngine } from './AthenaPresentationEngine';
import { AdaptiveResponseRenderer, resolveAdaptiveResponsePresentation } from './response-design/AdaptiveResponseRenderer';

export function ChatBubble({ message, isAthena = false, presentation, sessionId, messageId, timestamp }) {
  const adaptivePresentation = isAthena ? resolveAdaptiveResponsePresentation(presentation, message) : null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.3 }}
      className={`flex ${isAthena ? 'justify-start' : 'justify-end'} mb-3`}
      data-testid={isAthena ? 'athena-message' : 'user-message'}
    >
      <div
        className={`${adaptivePresentation ? 'w-full max-w-xl px-0 py-0 bg-transparent border-0' : 'max-w-xs px-4 py-2.5'} rounded-2xl text-sm ${
          isAthena
            ? (adaptivePresentation ? 'text-white/90' : 'bg-[#0a0a1a] border border-blue-500/10 text-white/90')
            : 'bg-blue-500/5 border border-blue-400/15 text-white/85'
        }`}
      >
        {isAthena && (
          <div className="flex items-center gap-1.5 mb-1">
            <div className="w-1.5 h-1.5 rounded-full bg-blue-400" />
            <span className="text-[10px] font-mono text-blue-400/70 tracking-wider uppercase">Athena</span>
          </div>
        )}
        {isAthena
          ? <AdaptiveResponseRenderer
              presentation={presentation}
              content={message}
              sessionId={sessionId}
              messageId={messageId}
              timestamp={timestamp}
              fallback={() => <AthenaPresentationEngine content={message} />}
            />
          : <p className="leading-relaxed">{message}</p>}
      </div>
    </motion.div>
  );
}
